
















import { Vue, Component } from "vue-property-decorator";
import ExpulsionOrderForm from "@/components/expulsion/ExpulsionOrderForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
@Component({
  components: { CBreadCrumbs, ExpulsionOrderForm }
})
export default class ExpulsionOrderNew extends Vue {
  get breadcrumbs() {
    return [
      {
        to: { name: "expulsionList" },
        label: this.$tc(this.$translate.OrdersOfCompletion)
      },
      {
        label: this.$tc(this.$translate.Create)
      }
    ];
  }
}
